import { createApi } from '@reduxjs/toolkit/query/react';

import { REFETCH_CURRENT_USER_SUCCESS } from '../../store/DEPRECATEDusers';
import { createBaseQuery } from './createBaseQuery';


type User = {
  id: string;
  email: string;
  hasSubscription: boolean;
  [key: string]: unknown;
};

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getCurrentUser: builder.query<User, void>({
      query: () => ({
        url: '/me',
        method: 'GET',
        requiresAuth: true,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: user } = await queryFulfilled;

          dispatch({
            type: REFETCH_CURRENT_USER_SUCCESS,
            payload: user,
          });
        } catch (err) {
          throw err;
        }
      },
      providesTags: ['User'],
    }),
  }),
});

export const { useGetCurrentUserQuery, useLazyGetCurrentUserQuery } = userApi; 